export default "__VITE_ASSET__1RQL8C_e__"